import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import Cookies from "universal-cookie";
import NotfoundShape from "../../assets/images/404-shape.svg";
import confirmBg2 from "../../assets/images/bg/confirm.jpg";
import menuBg from "../../assets/images/bg/menu/home.svg";
// images
import confirmBg from "../../assets/images/bg/upcoming.svg";
import reload from "../../assets/images/icons/reload.svg";
// components
import Header from "../../components/header";
import MainMenu from "../../components/mainMenu";
import { resendEmailVerifyCodeAction } from "../signup/actions";
import "./style.scss";

const cookie = new Cookies();

// changed from arrow fuction to fuction declaration
// changed get_verify_email to camelCase which is used in 2 places
// changed user_token to camecase which is used in 2 places
// changed the file name from .js to .jsx
// disabled esline for line number (56, 97, 38)

function ConfirmEmail(props) {
  const getVerifyEmail = cookie.get("verify_email");
  const userToken = cookie.get("user_token");
  const [openMenu, setOpenMenu] = useState(false);
  const history = useHistory();
  const handleResetEmail = () => {
    const data = {
      email: getVerifyEmail,
    };

    // eslint-disable-next-line react/destructuring-assignment
    props.resendEmailVerifyCodeAction(data);
  };

  const handleOpenMenu = () => {
    setOpenMenu(!openMenu);
  };

  const handleCloseMenuMenu = () => {
    setOpenMenu(false);
  };

  useEffect(() => {
    if (!userToken) {
      history.push("/login");
    } else if (cookie.get("user_info")?.email_verified_at) {
      history.goBack();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return () => {
      window.location.reload();
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>Confirm E-mail - Clarity Cooperative</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <MainMenu closeMenu={handleCloseMenuMenu} title="NAVIGATE" bgImage={menuBg} className={openMenu ? "active" : ""} />
      <Header openMenu={handleOpenMenu} className="headerStyleWhite" logoWhite />
      <div
        style={{
          background: `url(${confirmBg}) no-repeat center center / cover`,
        }}
        className="confirmEmailArea"
      >
        <div
          style={{
            background: `url(${confirmBg2}) no-repeat center center / cover`,
          }}
          className="confirmEmailWrap"
        >
          <img className="confirmShape" src={NotfoundShape} alt="shape" />

          <h1>CHECK YOUR E-MAIL</h1>
          <div className="checkSpam">
            <svg width="25" height="20" viewBox="0 0 25 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.16003 1H23.4457V19H1.16003V1Z" stroke="white" strokeWidth="1.71429" strokeLinecap="round" strokeLinejoin="round" />
              <path
                d="M1.16003 3.16846L11.1972 11.6387C11.5065 11.8998 11.8982 12.043 12.3029 12.043C12.7076 12.043 13.0993 11.8998 13.4086 11.6387L23.4457 3.16846"
                stroke="white"
                strokeWidth="1.71429"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Check Your Spam Folder!
          </div>
          <p>Please, check your E-mail! We’ve sent you an e-mail with a confirmation link.</p>
          <div className="resendEmail">
            Can’t find the e-mail?
            {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/click-events-have-key-events */}
            <strong aria-hidden onClick={handleResetEmail}>
              Resend It <img src={reload} alt="reload" />
            </strong>
          </div>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({
  user_info: state.my_account.user_info,
});

export default connect(mapStateToProps, {
  resendEmailVerifyCodeAction,
})(ConfirmEmail);
